import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall} from './ajaxStatusActions';

export function getPreguntaListSuccess(pregunta) {
  return {type: types.LOAD_PREGUNTA_LIST_SUCCESS, pregunta};
}



export function getPreguntaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token) {
    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PreguntaApi.getPreguntaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token).then(pregunta => {                  
                  dispatch(getPreguntaListSuccess(pregunta));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}



export function getPreguntaSuccess(catalogo) {
  return {type: types.LOAD_PREGUNTA_SUCCESS, catalogo};
}

export function getPregunta(id, token) {
    return dispatch => {
        dispatch(beginAjaxCall());  
        return Api().PreguntaApi.getPregunta(id, token).then(pregunta => {   
        dispatch(getPreguntaSuccess(pregunta));
        return pregunta;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function saveSuccess(pregunta) {
  return {type: types.SAVE_PREGUNTA_SUCCESS, pregunta};
}


export function save(pregunta, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().PreguntaApi.save(pregunta, token).then(preguntaGuardado => {
    dispatch(saveSuccess(preguntaGuardado));
    return preguntaGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function saveImage(file, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().PreguntaApi.saveImage(file, token).then(imagenGuardado => {
    dispatch(saveSuccess(imagenGuardado));
    return imagenGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function saveQuestionImage(file, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().PreguntaApi.saveQuestionImage(file, token).then(imagenPreguntaGuardado => {
    dispatch(saveSuccess(imagenPreguntaGuardado));
    return imagenPreguntaGuardado;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}


export function deleteQuestionImage(preguntaId, token) {
    
  return dispatch => {
	dispatch(beginAjaxCall());  
    return Api().PreguntaApi.deleteQuestionImage(preguntaId, token).then(imagenPreguntaBorrada => {
    dispatch(saveSuccess(imagenPreguntaBorrada));
    return imagenPreguntaBorrada;
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}




export function getPreguntaComboSuccess(datos) {
  return {type: types.GET_PREGUNTAS_COMBO_SUCCESS, datos};
}

export function getPreguntaCombo(token) {
    
  return dispatch => {
     
	dispatch(beginAjaxCall());  
      
    return Api().PreguntaApi.getPreguntaCombo(token).then(datos => {   
        
      dispatch(getPreguntaComboSuccess(datos));
    }).catch(error => {
		dispatch(ajaxCallError()); 
      throw(error);
    });
  };
}

export function borrarSuccess(pregunta) {
  return {type: types.BORRAR_PREGUNTA_SUCCESS, pregunta};
}


export function borrar(id, token ) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PreguntaApi.borrar(id, token ).then(pregunta => {
               
                  dispatch(borrarSuccess(pregunta));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}




export function activarSuccess(pregunta) {
  return {type: types.ACTIVAR_PREGUNTA_SUCCESS, pregunta};
}


export function activar(id, token) {    
	return dispatch => {
		      dispatch(beginAjaxCall());
		      return Api().PreguntaApi.activar(id, token).then(pregunta => {
               
                  dispatch(activarSuccess(pregunta));
		      }).catch(error => {
		          dispatch(ajaxCallError());
		  throw(error);
		});
  	};
}


export function setFiltro(filtroActivo, filtroActual, showActivos, filtrosCombo) {
	let filtro={
		filtroActivo,
		filtroActual,
        showActivos,
        filtrosCombo
	}
  return {type: types.SET_FILTRO_PREGUNTA, filtro};
}



